import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

import { DashboardDateRangeFilter } from './dashboard-filter/dashboard-filter-type.enum';
import { debounceTime } from 'rxjs/operators';

@Component({
    selector: 'app-dashboard',
    host: { 'data-testid': 'dashboard-page' },
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: false
})
export class DashboardComponent implements OnInit {

    public filterForm: UntypedFormGroup;

    constructor(private formBuilder: UntypedFormBuilder) { }

    ngOnInit() {
        this.initForm();
    }

    initForm() {
        this.filterForm = this.formBuilder.group({
            'dateRange': [DashboardDateRangeFilter.Last30Days, []],
            'campType': [null, []],
        });

        this.filterForm.valueChanges
            .pipe(debounceTime(100))
            .subscribe(() => {
            });
    }
}
